module.exports = __webpack_public_path__ + "static/baris-pinduk-79bb5f0a0b1f793b6a707347495f7f4e.webp";